import { render, staticRenderFns } from "./inventoryStat.vue?vue&type=template&id=a4388ba6&scoped=true&"
import script from "./inventoryStat.vue?vue&type=script&lang=js&"
export * from "./inventoryStat.vue?vue&type=script&lang=js&"
import style0 from "./inventoryStat.vue?vue&type=style&index=0&id=a4388ba6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4388ba6",
  null
  
)

component.options.__file = "inventoryStat.vue"
export default component.exports